const prefix = ''

export const alertRuleUrls = {
  'alertRule.list': `${prefix}/alert-rules`,
  'alertRule.view': (id = ':alertRuleId') => `${prefix}/alert-rules/${id}`,
  'alertRule.edit': (id = ':alertRuleId') => `${prefix}/alert-rules/${id}/edit`,
}
